import { isEmpty } from "lodash";
import { RENDER_MESSAGE_TYPE_CATALOG } from "../../constants";

export const handleMessageTypeCatalog = (conversationId, message) => (dispatch, getState) => {
    
    const tabStack = getState().tabStack;
    if (tabStack && !isEmpty(tabStack)) {
        const tabStackData = tabStack?.[conversationId];
        let updatedTabStackData;

        // For catalog messages, we typically don't have actions like other message types
        // So we'll use a simple update pattern
        updatedTabStackData = {
            ...tabStackData,
            components: tabStackData?.components || [],
        };

        // Add or update the catalog component
        const existingCatalogIndex = updatedTabStackData.components.findIndex(
            component => component.messageType === message.messageType
        );

        if (existingCatalogIndex >= 0) {
            // Update existing catalog component
            updatedTabStackData.components[existingCatalogIndex] = message;
        } else {
            // Add new catalog component
            updatedTabStackData.components.push(message);
        }

        // Set selected tab if not updating in background
        if (!message.options?.updateInBackground) {
            updatedTabStackData = {
                ...updatedTabStackData,
                selectedTab: message?.options?.tabId,
            };
        }

        dispatch({
            type: RENDER_MESSAGE_TYPE_CATALOG,
            data: { [conversationId]: updatedTabStackData },
        });
    } else {
        // Create new tab stack entry for this conversation
        const data = {
            [conversationId]: {
                components: [message],
            },
        };

        if (!message.options?.updateInBackground) {
            data[conversationId].selectedTab = message.options.tabId;
        }

        dispatch({
            type: RENDER_MESSAGE_TYPE_CATALOG,
            data: data,
        });
    }
};